var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin1W(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.33 67.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #f24726;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.33,26.66C53.33,11.94,41.39,0,26.66,0S0,11.94,0,26.66c0,6.94,2.66,13.27,7.01,18.01h0l19.66,23.19,19.66-23.19h0c4.35-4.74,7.01-11.07,7.01-18.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.66,
    cy: 26.66,
    r: 17.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.68,
    y: 34.39,
    width: 17.97,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.22,
    y: 31.33,
    width: 12.89,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.18 17.52 26.66 14.94 24.14 17.52 24.14 30.27 29.18 30.27 29.18 17.52"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin1W);
export default __webpack_public_path__ + "static/media/pin1W.2f605ab40b42e23143e1e5eb6ae40921.svg";
export { ForwardRef as ReactComponent };